/**
 * 画像アップロードの入口制限（店舗画像）。
 *
 * 画面表記は「JPG・PNG形式」なのに accept="image/*" だったため、ダイアログで SVG や HEIC を
 * 選べてしまい、サーバ側の許可リスト（jpeg/png/gif/webp）で弾かれて汎用エラーだけが出ていた
 * （動作確認NG: 7章 7-1 店舗画像）。入口を表記どおりに狭める。
 */

/** file input の accept 属性。拡張子も併記するのは、MIME を返さない端末で選べなくなるのを防ぐため */
export const IMAGE_ACCEPT_JPEG_PNG = 'image/jpeg,image/png,.jpg,.jpeg,.png';

/** ユーザーに出す拒否メッセージ（accept はあくまでヒントで、全ファイル選択に切り替えられる） */
export const IMAGE_TYPE_ERROR_MESSAGE = 'JPG または PNG 形式の画像を選択してください。';

const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png'];
const ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png'];

/**
 * JPG / PNG かどうかを判定する。
 * HEIC などは端末によって file.type が空文字になるため、MIME が空のときだけ拡張子で判定する
 * （MIME があるのに許可外＝SVG 等は、拡張子を偽装されても弾く）。
 */
export const isJpegOrPng = (file: File): boolean => {
  if (file.type) {
    return ALLOWED_MIME_TYPES.includes(file.type);
  }
  const name = (file.name || '').toLowerCase();
  return ALLOWED_EXTENSIONS.some((ext) => name.endsWith(ext));
};
